export const mapReleaseOSToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfRelease: item.releaseAppVersions?.length,
  }));

  return result;
};

export const releaseOSColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "operatingSystem", label: "Operating Systems", align: "center" },
  { key: "numOfRelease", label: "Num Of Release Version", align: "center" },
];
